// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"43":"python","443":"about","767":"details"}[chunkId] + "." + {"43":"9996eff2","443":"181061ce","767":"744e682a"}[chunkId] + ".css";
};